import React, { useEffect, useState } from 'react';
import { Carousel } from 'react-bootstrap';
import { useParams } from 'react-router-dom';

export const PortafolioDetails = () => {

    const { id } = useParams();
    const [repoData, setRepoData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchMetadata = async () => {
            setLoading(true);
            setError(null);
            try {
                const response = await fetch('/metadatainfo.json');
                if (!response.ok) {
                    throw new Error('Failed to fetch metadata');
                }
                const data = await response.json();
                setRepoData(data[id]);
            } catch (err) {
                setError('Failed to fetch repository data.');
            } finally {
                setLoading(false);
            }
        };

        fetchMetadata();
    }, [id]);

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error}</p>;
    if (!repoData) return <p>No data available.</p>;

    const { title, subtitle, description, project_date, client, category, images, url_project } = repoData;

    return (
        <>
            <div className="page-title dark-background">
                <div className="container d-lg-flex justify-content-between align-items-center">
                    <h1 className="mb-2 mb-lg-0">Portfolio Detalle</h1>
                </div>
            </div>
            <section id="portfolio-details" className="portfolio-details section">
                <div className="container" data-aos="fade-up" data-aos-delay="100">
                    <div className="row gy-4">
                        <div className="col-lg-8">
                            <div className="portfolio-details-slider swiper init-swiper">
                                <div className="swiper-wrapper align-items-center">
                                    <Carousel>
                                        {images.map((image, index) => (
                                            <Carousel.Item key={index}>
                                                <img
                                                    className="d-block w-100"
                                                    src={image}
                                                    alt={`Imagen del proyecto ${index + 1}`}
                                                />
                                            </Carousel.Item>
                                        ))}
                                    </Carousel>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4">
                            <div className="portfolio-info" data-aos="fade-up" data-aos-delay="200">
                                <h3>{title}</h3>
                                <ul>
                                    <li><strong>Categoria:</strong> {category}</li>
                                    <li><strong>Cliente:</strong> {client}</li>
                                    <li><strong>Fecha proyecto:</strong> {project_date}</li>
                                    <li>
                                        <strong>Url: </strong>
                                        {url_project ? (
                                            <a href={url_project} target="_blank" rel="noopener noreferrer">
                                                {url_project}
                                            </a>
                                        ) : (
                                            'No disponible publicamente'
                                        )}
                                    </li>
                                </ul>
                            </div>
                            <div className="portfolio-description" data-aos="fade-up" data-aos-delay="300">
                                <h2>{subtitle}</h2>
                                <p>{description}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};
